<template>
  <b-modal
    v-model="showModal"
    size="lg"
    modal-class="modal-descuentos"
    hide-footer
  >
    <template #modal-header="{ close }">
      <div class="w-100 bg-celeste py-2 px-3 d-flex
        justify-content-between align-items-center text-center">
        <h5 class="mb-0">Pre Liquidacion - Descuentos</h5>
        <button
          type="button"
          class="close"
          @click="close()"
        >&times;</button>
      </div>
    </template>
    <div class="table-responsive">
      <table class="table table-sm table-bordered mb-0">
        <thead>
          <tr class="btn-gray-300">
            <th width="40%">Servicio</th>
            <th width="10%" class="text-center">Fecha</th>
            <th width="15%" class="text-center">P/U</th>
            <th width="15%" class="text-center">Desc.</th>
            <th width="20%" class="text-center">Importe</th>
          </tr>
        </thead>
        <!-- Servicios complementarios agrupados -->
        <tbody
          v-for="(grupo, gIndex) in descuentosAgrupados"
          :key="'g-' + gIndex"
        >
          <tr>
            <td colspan="4" class="font-weight-bold">
              {{ grupo.nombre }}
            </td>
            <td class="text-right font-weight-bold">
              Total: {{ formatNumber(grupo.total) }}
            </td>
          </tr>
          <tr
            v-for="(item, iIndex) in grupo.items"
            :key="'s-' + gIndex + '-' + iIndex"
          >
            <td class="pl-4">{{ item.cantidad }} <span v-if="item.cantidad">-</span>  {{ item.nombre }}</td>
            <td class="text-center">{{ item.fecha }}</td>
            <td class="text-center">
              {{ formatNumber(item.precio_unitario) }}
            </td>
            <td class="text-center">
               <vue-numeric
                class="form-control form-control-sm text-center"
                v-model="item.descuento"
                separator=","
                :precision="2"
                :max="parseFloat(item.precio_unitario) || 0"
                :disabled="aplicarDescuentoGeneral"
              />
            </td>
            <td class="text-right">
              {{ formatNumber(calcularImporteItem(item)) }}
            </td>
          </tr>
        </tbody>
        <!-- Sala/Cama - cada cama como fila expandible -->
        <tbody v-if="camasSeleccionadas.length > 0">
          <tr>
            <td colspan="4" class="font-weight-bold">
              Sala / Cama
            </td>
            <td class="text-right font-weight-bold">
              Total: {{ formatNumber(totalCamaDescuentos) }}
            </td>
          </tr>
          <template
            v-for="(cama, cIndex) in camasSeleccionadas"
          >
            <tr
              :key="'cama-' + cIndex"
              style="cursor: pointer;"
              :class="camasExpandidas.includes(cIndex)
                ? 'table-active' : ''"
              @click="toggleExpandCama(cIndex)"
            >
              <td class="pl-4">
                <i
                  :class="camasExpandidas.includes(cIndex)
                    ? 'nav-icon i-Arrow-Down'
                    : 'nav-icon i-Arrow-Right'"
                  class="mr-1"
                ></i>
                {{ cama.piso_sala_nombre }}
                - {{ cama.cama_nombre }}
              </td>
              <td class="text-center">
                {{ cama.tiempo || 1 }}
              </td>
              <td class="text-center">
                {{ formatNumber(cama.importe_x_dia) }}
              </td>
              <td class="text-center">
                {{ cama.estado }}
              </td>
              <td class="text-right">
                {{ formatNumber(totalCamaPorIndex(cIndex)) }}
              </td>
            </tr>
            <!-- Dias expandidos de la cama -->
            <template v-if="camasExpandidas.includes(cIndex)">
              <tr
                v-for="(dia, dIndex) in camasDias[cIndex]"
                :key="'dia-' + cIndex + '-' + dIndex"
                :style="dia.anulado
                  ? 'text-decoration: line-through; opacity: 0.5;'
                  : ''"
              >
                <td class="pl-5" style="font-size: 0.85em;">
                  <i
                    class="nav-icon i-Close-Window text-danger"
                    style="cursor: pointer; font-weight: bold;"
                    @click.stop="toggleAnularDia(cIndex, dIndex)"
                  ></i>
                  &nbsp; Dia {{ dIndex + 1 }}
                </td>
                <td class="text-center"
                  style="font-size: 0.85em;">
                  1
                </td>
                <td class="text-center"
                  style="font-size: 0.85em;">
                  {{ formatNumber(dia.costo) }}
                </td>
                <td class="text-center"
                  style="font-size: 0.85em;">
                  {{ dia.fecha }}
                </td>
                <td class="text-right"
                  style="font-size: 0.85em;">
                  {{ dia.anulado
                    ? '0.00'
                    : formatNumber(dia.costo) }}
                </td>
              </tr>
            </template>
          </template>
        </tbody>
      </table>
    </div>
    <!-- Footer -->
    <div class="line"></div>
    <div class="row">
      <div class="col-sm-6">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="noFigurarDescuento"
            v-model="noFigurarDescuento"
          >
          <label
            class="form-check-label"
            for="noFigurarDescuento"
            style="color: red;"
          >
            No figurara en la Venta el Descuento.
          </label>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="d-flex justify-content-end mb-1">
          <span class="font-weight-bold mr-2">
            Sub Total:
          </span>
          <span class="font-weight-bold">
            {{ formatNumber(subTotal) }}
          </span>
        </div>
        <div
          class="d-flex justify-content-end align-items-center mb-1"
        >
          <input
            type="checkbox"
            class="mr-2"
            v-model="aplicarDescuentoGeneral"
            :disabled="noFigurarDescuento"
          >
          <span class="mr-2">Desc.:</span>
          <vue-numeric
                class="form-control form-control-sm text-center"
                v-model="descuentoGeneral"
                separator=","
                :precision="2"
                :max="subTotal"
                :disabled="!aplicarDescuentoGeneral || noFigurarDescuento"
                style="width: 100px;"
              />
        </div>
        <div class="d-flex justify-content-end">
          <span class="font-weight-bold mr-2">Total:</span>
          <span class="font-weight-bold">
            {{ formatNumber(totalFinal) }}
          </span>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-sm-12 d-flex justify-content-left">
        <button
          class="btn btn-secondary"
          @click="cancelar"
        >
          Cancelar
        </button>
        <button
          class="ml-3 btn btn-success"
          @click="guardar"
        >
          Guardar
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState } from 'vuex';
import {
  CATEGORIA_SERVICIO_COMPL,
} from '@/utils/globalConventions';
import VueNumeric from 'vue-numeric';

const CATEGORIA_NOMBRES = {
  [CATEGORIA_SERVICIO_COMPL.ECOGRAFIA]: 'Ecografia',
  [CATEGORIA_SERVICIO_COMPL.RAYOS_X]: 'Rayos X',
  [CATEGORIA_SERVICIO_COMPL.TOMOGRAFIA]: 'Tomografia',
  [CATEGORIA_SERVICIO_COMPL.MAMOGRAFIA]: 'Mamografia',
  [CATEGORIA_SERVICIO_COMPL.ARCO_C]: 'Arco en C',
  [CATEGORIA_SERVICIO_COMPL.FISIOTERAPIA]: 'Fisioterapia',
  [CATEGORIA_SERVICIO_COMPL.TRATAMIENTO]: 'Tratamiento',
  [CATEGORIA_SERVICIO_COMPL.FARMACIA]: 'Farmacia',
  [CATEGORIA_SERVICIO_COMPL.LABORATORIO]: 'Laboratorio',
};

export default {
  name: 'TheModalDescuentos',
  components: {
    VueNumeric,
  },
  props: {
    servicioComplementario: {
      type: Array,
      default: () => [],
    },
    diasTratamiento: {
      type: Number,
      default: 0,
    },
    fechaInicio: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      descuentosItems: [],
      initialDescuentos: [],
      camasDias: {},
      camasExpandidas: [],
      descuentoGeneral: 0,
      aplicarDescuentoGeneral: false,
      noFigurarDescuento: false,
      isOpeningModal: false,
      tratamientoId: null,
    };
  },
  watch: {
    aplicarDescuentoGeneral(activo) {
      if (this.isOpeningModal) return;
      this.descuentoGeneral = 0;
      if (activo) {
        this.descuentosItems.forEach((item) => {
          // eslint-disable-next-line no-param-reassign
          item.descuento = 0;
        });
      }
    },
    totalDescuentoIndividual(val) {
      if (!this.aplicarDescuentoGeneral) {
        this.descuentoGeneral = val;
      }
    },
  },
  computed: {
    ...mapState('modalPieza', {
      listaCamas: 'tablaModal',
    }),
    camasSeleccionadas() {
      return this.listaCamas.filter((c) => c.checkInput);
    },
    descuentosAgrupados() {
      const grupos = {};
      this.descuentosItems.forEach((item) => {
        if (!grupos[item.grupo]) {
          grupos[item.grupo] = {
            nombre: item.grupo,
            items: [],
            total: 0,
          };
        }
        grupos[item.grupo].items.push(item);
      });
      Object.keys(grupos).forEach((k) => {
        let total = 0;
        grupos[k].items.forEach((item) => {
          total += this.calcularImporteItem(item);
        });
        // eslint-disable-next-line no-param-reassign
        grupos[k].total = total;
      });
      return Object.keys(grupos).map((k) => grupos[k]);
    },
    totalCamaDescuentos() {
      let total = 0;
      this.camasSeleccionadas.forEach((cama, cIndex) => {
        const dias = this.camasDias[cIndex];
        if (!dias || dias.length === 0) {
          total += (parseFloat(cama.importe_x_dia) || 0) * (cama.tiempo || 1);
        } else {
          dias.forEach((dia) => {
            if (!dia.anulado) {
              total += parseFloat(dia.costo) || 0;
            }
          });
        }
      });
      return total;
    },
    subTotal() {
      let total = 0;
      this.descuentosAgrupados.forEach((grupo) => {
        total += grupo.total;
      });
      total += this.totalCamaDescuentos;
      return total;
    },
    totalDescuentoIndividual() {
      let total = 0;
      this.descuentosItems.forEach((item) => {
        total += parseFloat(item.descuento) || 0;
      });
      return total;
    },
    totalDescuento() {
      const descGeneral = this.aplicarDescuentoGeneral
        ? (parseFloat(this.descuentoGeneral) || 0)
        : 0;
      return this.totalDescuentoIndividual + descGeneral;
    },
    totalFinal() {
      const desc = this.aplicarDescuentoGeneral
        ? (parseFloat(this.descuentoGeneral) || 0)
        : 0;
      return this.subTotal - desc;
    },
  },
  methods: {
    abrir(initialData = {}) {
      this.isOpeningModal = true;
      this.tratamientoId = initialData.tratamientoId ?? null;
      this.cargarServicios();
      this.camasExpandidas = [];
      this.descuentoGeneral = initialData.descuentoMonto || 0;
      this.aplicarDescuentoGeneral = initialData.descuentoGeneral === 1
        || initialData.aplicarDescuentoGeneral || false;
      this.noFigurarDescuento = initialData.noFigurarDescuento || false;
      const tieneDiasCargados = initialData.diasCargados
        && initialData.diasCargados.length > 0;
      const tieneCamasGuardadas = initialData.camasDias
        && Object.keys(initialData.camasDias).length > 0;
      const diasCargados = tieneDiasCargados ? initialData.diasCargados : null;
      const camasGuardadas = tieneCamasGuardadas ? initialData.camasDias : null;
      this.showModal = true;
      this.$nextTick(() => {
        const nuevoCamasDias = {};
        if (diasCargados && this.camasSeleccionadas.length > 0) {
          this.camasSeleccionadas.forEach((cama, cIndex) => {
            nuevoCamasDias[cIndex] = diasCargados.map((dia) => {
              let anulado = dia.estado === 0 || dia.estado === false;
              if (camasGuardadas && camasGuardadas[cIndex]) {
                const saved = camasGuardadas[cIndex].find((d) => d.id === dia.id);
                if (saved) anulado = saved.anulado;
              }
              return {
                id: dia.id,
                fecha: dia.fecha
                  ? dia.fecha.split('-').reverse().join('/')
                  : dia.fecha,
                costo: parseFloat(cama.importe_x_dia) || 0,
                anulado,
              };
            });
          });
        } else if (camasGuardadas) {
          Object.keys(camasGuardadas).forEach((k) => {
            nuevoCamasDias[k] = camasGuardadas[k].map((d) => ({ ...d }));
          });
        }
        this.camasDias = nuevoCamasDias;
        this.camasExpandidas = this.camasSeleccionadas.map((_, i) => i);
        this.isOpeningModal = false;
      });
    },
    cargarServicios() {
      const items = [];
      this.servicioComplementario.forEach((sc) => {
        if (!sc.estado) return;
        const cantidad = parseInt(sc.cantidad, 10) || 1;
        const precio = parseFloat(sc.precio) || 0;
        const precioUnitario = cantidad > 0
          ? precio / cantidad : precio;
        const grupoNombre = CATEGORIA_NOMBRES[
          sc.categoria_serv_compl_id
        ] || sc.categoria || 'Otros';
        const fecha = sc.fecha_hora.split(' ')[0].split('-').reverse().join('/');
        items.push({
          nombre: sc.nombre,
          grupo: grupoNombre,
          cantidad,
          precio_unitario: precioUnitario,
          descuento: parseFloat(sc.descuento_unitario) || 0,
          fecha,
        });
      });
      this.descuentosItems = items;
      this.initialDescuentos = items.map((i) => i.descuento);
    },
    toggleExpandCama(cIndex) {
      const idx = this.camasExpandidas.indexOf(cIndex);
      if (idx >= 0) {
        this.camasExpandidas.splice(idx, 1);
      } else {
        this.camasExpandidas.push(cIndex);
      }
    },
    toggleAnularDia(cIndex, dIndex) {
      const dia = this.camasDias[cIndex][dIndex];
      this.$set(dia, 'anulado', !dia.anulado);
    },
    totalCamaPorIndex(cIndex) {
      const dias = this.camasDias[cIndex];
      if (!dias || dias.length === 0) {
        const cama = this.camasSeleccionadas[cIndex];
        return cama
          ? (parseFloat(cama.importe_x_dia) || 0) * (cama.tiempo || 1)
          : 0;
      }
      return dias.reduce(
        (sum, dia) => sum + (!dia.anulado ? parseFloat(dia.costo) || 0 : 0),
        0,
      );
    },
    calcularImporteItem(item) {
      const total = (item.precio_unitario * item.cantidad)
        - (parseFloat(item.descuento) || 0);
      return total > 0 ? total : 0;
    },
    formatNumber(value) {
      return parseFloat(value || 0).toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    cancelar() {
      this.showModal = false;
    },
    guardar() {
      this.$emit('guardarDescuentos', {
        items: this.descuentosItems,
        camasDias: this.camasDias,
        aplicarDescuentoGeneral: this.aplicarDescuentoGeneral,
        descuentoGeneral: this.aplicarDescuentoGeneral
          ? this.descuentoGeneral : 0,
        noFigurarDescuento: this.noFigurarDescuento,
        subTotal: this.subTotal,
        total: this.totalFinal,
        descuentoItemsChanged: this.descuentosItems.some(
          (item, i) => item.descuento !== this.initialDescuentos[i],
        ),
      });
      this.showModal = false;
    },
  },
};
</script>
<style>
.bg-celeste {
    background: #d0edff !important;
}
.modal-descuentos .modal-header {
    padding: 0 !important;
    border-bottom: none;
}
.modal-descuentos .modal-header .bg-celeste{
    border-radius: 0.3rem 0.3rem 0 0;
}
.line {
  border-top: 1px solid #000;
    margin: 10px 0;
}
.modal-descuentos td {
    padding: 0.15rem 0.4rem !important;
    vertical-align: middle !important;
}
.modal-descuentos .form-control-sm {
    padding: 0.1rem 0.3rem !important;
    height: 26px !important;
}
</style>
